var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaction3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 24C40.25 15.025 32.975 7.75 24 7.75C15.025 7.75 7.75 15.025 7.75 24C7.75 32.975 15.025 40.25 24 40.25C32.975 40.25 40.25 32.975 40.25 24ZM4 24C4 12.9547 12.9547 4 24 4C35.0453 4 44 12.9547 44 24C44 35.0453 35.0453 44 24 44C12.9547 44 4 35.0453 4 24ZM15.2812 20.25C15.2812 18.8695 16.4008 17.75 17.7812 17.75C19.1617 17.75 20.2812 18.8695 20.2812 20.25C20.2812 21.6305 19.1617 22.75 17.7812 22.75C16.4008 22.75 15.2812 21.6305 15.2812 20.25ZM30.2812 17.75C31.6617 17.75 32.7812 18.8695 32.7812 20.25C32.7812 21.6305 31.6617 22.75 30.2812 22.75C28.9008 22.75 27.7812 21.6305 27.7812 20.25C27.7812 18.8695 28.9008 17.75 30.2812 17.75ZM30.0883 33.7008H17.9117C17.0234 33.7008 16.3039 32.8266 16.3039 31.7477C16.3039 30.6688 17.0234 29.7945 17.9117 29.7945H30.0883C30.9766 29.7945 31.6961 30.6688 31.6961 31.7477C31.6961 32.8266 30.9766 33.7008 30.0883 33.7008Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction3);
export default __webpack_public_path__ + "static/media/reaction-3.d98c517b890424cb8858c579eebaf61e.svg";
export { ForwardRef as ReactComponent };